import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { TabFile } from './tabFile';
import { TabUnique } from './tabUnique';

export const Classifier = () => {
  return (
    <Box
      style={{
        width: '100%',
        height: 'calc(100vh - 50px)',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <BoxHeader>
        <img
          src="https://imagens-design.londrisoftservices.com.br/workspace/initial/images/header_clas2.png"
          alt="Logo"
        />
      </BoxHeader>
      <BoxContent>
        <Tabs
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
          }}
          sx={{ fontFamily: 'Inter' }}
        >
          <TabListCustom>
            <Tab
              _focus={{ boxShadow: 'none' }}
              _selected={{ color: '#3A86FF', borderColor: '#3A86FF' }}
              color="#A1A1AA"
            >
              Individual
            </Tab>
            <Tab
              _focus={{ boxShadow: 'none' }}
              _selected={{ color: '#3A86FF', borderColor: '#3A86FF' }}
              color="#A1A1AA"
              sx={{ whiteSpace: 'nowrap' }}
            >
              Em lote
            </Tab>
            {/* <Tab
              _focus={{ boxShadow: 'none' }}
              _selected={{ color: '#3A86FF', borderColor: '#3A86FF' }}
              color="#A1A1AA"
            >
              Histórico
            </Tab> */}
          </TabListCustom>

          <TabPanels
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
            }}
          >
            <TabPanel
              style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                padding: '20px',
                overflow: 'auto',
              }}
            >
              <TabUnique />
            </TabPanel>
            <TabPanel
              style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                padding: '20px',
                overflow: 'auto',
              }}
            >
              <TabFile />
            </TabPanel>
            <TabPanel
              style={{
                flex: 1,
                padding: 0,
                overflow: 'hidden',
              }}
            >
              Histórico
            </TabPanel>
          </TabPanels>
        </Tabs>
      </BoxContent>
    </Box>
  );
};

const BoxHeader = styled(Box)`
  background: #ffff;
  padding-top: 16px;
  padding-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BoxContent = styled(Box)`
  background: #ffff;
  margin-top: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const TabListCustom = styled(TabList)`
  border-bottom: 1px solid #e2e8f0;
  position: relative;
  z-index: 1;
  width: 190px;
`;

